/* eslint-disable import/no-cycle */

import { call, put, takeEvery } from 'redux-saga/effects';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import { returnVouchers } from '../../api/api';
import {
  GET_RETURN_VOUCHERS,
  GET_RETURN_VOUCHERS_SUCCESS,
  GET_RETURN_VOUCHERS_FAILURE,
  GET_RETURN_VOUCHER,
  GET_RETURN_VOUCHER_SUCCESS,
  GET_RETURN_VOUCHER_FAILURE,
  CANCEL_RETURN_VOUCHER,
  CANCEL_RETURN_VOUCHER_SUCCESS,
  UPDATE_RETURN_VOUCHER,
  UPDATE_RETURN_VOUCHER_SUCCESS
} from './vouchersActions';

import logger from '../../utils/logger';

export function* getReturnVouchers(action) {
  try {
    const response = yield call(
      returnVouchers.getReturnVouchers,
      action.payload
    );
    if (response.data.success === true) {
      yield put({ type: GET_RETURN_VOUCHERS_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_RETURN_VOUCHERS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_RETURN_VOUCHERS_FAILURE });
  }
}

export function* getReturnVoucher(action) {
  try {
    const response = yield call(
      returnVouchers.getReturnVoucher,
      action.payload
    );
    if (response.data.success === true) {
      yield put({ type: GET_RETURN_VOUCHER_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_RETURN_VOUCHER_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_RETURN_VOUCHER_FAILURE });
  }
}

export function* cancelReturnVoucher(action) {
  const closeLoading = displayLoading(`Annulation du bon de retour en cours`);
  try {
    const response = yield call(returnVouchers.cancel, action.payload);
    if (response.data.success === true) {
      yield put({
        type: CANCEL_RETURN_VOUCHER_SUCCESS,
        payload: response.data
      });
      closeLoading();
      displaySuccess('Bon de retour annuler avec succès');
    } else {
      closeLoading();
    }
  } catch (error) {
    logger(error);
  }
}

export function* updateReturnVoucher(action) {
  const closeLoading = displayLoading(`Mise à jour du bon de retour en cours`);
  try {
    const response = yield call(returnVouchers.update, action.payload);
    if (response.data.success === true) {
      yield put({
        type: UPDATE_RETURN_VOUCHER_SUCCESS,
        payload: response.data
      });
      displaySuccess('Bon de retour mise à jour avec succès');
    }
  } catch (error) {
    logger(error);
  } finally {
    closeLoading();
  }
}

const signinSaga = [
  takeEvery(GET_RETURN_VOUCHERS, getReturnVouchers),
  takeEvery(GET_RETURN_VOUCHER, getReturnVoucher),
  takeEvery(CANCEL_RETURN_VOUCHER, cancelReturnVoucher),
  takeEvery(UPDATE_RETURN_VOUCHER, updateReturnVoucher)
];

export default signinSaga;
